// extracted by css-extract-rspack-plugin
export default {"windowContent":"src-modules-desktop-pages-MainPage-components-WindowManager-components-Window-components-WindowContent-WindowContent-module__windowContent-y6qJiw","iframe":"src-modules-desktop-pages-MainPage-components-WindowManager-components-Window-components-WindowContent-WindowContent-module__iframe-Ku9gqD","componentWrapper":"src-modules-desktop-pages-MainPage-components-WindowManager-components-Window-components-WindowContent-WindowContent-module__componentWrapper-soOpwf"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"windowContent\":\"src-modules-desktop-pages-MainPage-components-WindowManager-components-Window-components-WindowContent-WindowContent-module__windowContent-y6qJiw\",\"iframe\":\"src-modules-desktop-pages-MainPage-components-WindowManager-components-Window-components-WindowContent-WindowContent-module__iframe-Ku9gqD\",\"componentWrapper\":\"src-modules-desktop-pages-MainPage-components-WindowManager-components-Window-components-WindowContent-WindowContent-module__componentWrapper-soOpwf\"}";
        // 1793872698269
        var cssReload = require("../../../../../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  